import {
  CANCEL_HEADING_USE_CASE,
  CancelHeadingUseCase,
  CREATE_HEADING_USE_CASE,
  CreateHeadingUseCase,
  DELETE_HEADING_USE_CASE,
  DeleteHeadingUseCase,
  FORM_REPOSITORY,
  IFormRepository,
  SAVE_HEADING_USE_CASE,
  SaveHeadingUseCase,
  AI_ACCEPT_HEADING_CHANGE_USE_CASE,
  AiAcceptHeadingChangeUseCase,
} from '@module/form';
import { Provider } from '@nestjs/common';

export const headingUseCaseProviders: Provider[] = [
  {
    provide: CREATE_HEADING_USE_CASE,
    useValue: new CreateHeadingUseCase(),
  },
  {
    provide: SAVE_HEADING_USE_CASE,
    useFactory: (formRepository: IFormRepository) => {
      return new SaveHeadingUseCase(formRepository);
    },
    inject: [FORM_REPOSITORY],
  },
  {
    provide: DELETE_HEADING_USE_CASE,
    useFactory: (formRepository: IFormRepository) => {
      return new DeleteHeadingUseCase(formRepository);
    },
    inject: [FORM_REPOSITORY],
  },
  {
    provide: CANCEL_HEADING_USE_CASE,
    useValue: new CancelHeadingUseCase(),
  },
  {
    provide: AI_ACCEPT_HEADING_CHANGE_USE_CASE,
    useFactory: (
      saveHeadingUseCase: SaveHeadingUseCase,
      deleteHeadingUseCase: DeleteHeadingUseCase,
    ) => new AiAcceptHeadingChangeUseCase(saveHeadingUseCase, deleteHeadingUseCase),
    inject: [SAVE_HEADING_USE_CASE, DELETE_HEADING_USE_CASE],
  },
];
